import useGetApi from 'src/api/useGetApi';
import useMutationApi from 'src/api/useMutationApi';
import { UserDocument } from 'src/types/UserDocuments';

export interface OCRResultDTO {
  id: string;
  vendor: string;
  modelVersion: string;
  promptVersion: string | null;
  customInstructions: string | null;
  extractedResult: Record<string, unknown> | null;
  status: string;
  error: string | null;
  processingMetadata: Record<string, unknown> | null;
  result: string | Record<string, unknown> | null;
  tokenUsage: {
    promptTokens?: number;
    completionTokens?: number;
    totalTokens?: number;
  } | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface GetDocumentResponse {
  document: UserDocument;
  signedUrl: string;
}

export interface GetDocumentWithOCRResponse extends GetDocumentResponse {
  ocrResults: OCRResultDTO[];
}

export const useGetDocumentWithOCR = (documentId?: string) => {
  return useGetApi<GetDocumentWithOCRResponse>({
    endpoint: `core/documents/${documentId}/ocr`,
    options: {
      enabled: !!documentId,
      // Prevent automatic refetching to avoid iframe re-renders
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      // Keep data fresh for 5 minutes to avoid unnecessary signed URL regeneration
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Cache for 10 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  });
};

export const useGetDocument = () => {
  return useMutationApi<{ documentId: string }, GetDocumentResponse>({
    endpoint: `core/documents/signed-url`,
    method: 'POST',
    showSuccessToast: false,
    successMessage: '',
  });
};
